// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Vl","modalContent":"Wl","header":"Xl","close":"Yl"};